angular.module('nv.routes.config').config(function($locationProvider) {
  $locationProvider.html5Mode({
    enabled: true,
    requireBase: true,
  });
});
